/* eslint-disable no-param-reassign */
import React from 'react';
import PropTypes from 'prop-types';
import DropdownMultiItemCheckboxComponent from './DropdownMultiItemCheckboxComponent';
import DropdownMultiItemFilterComponent from './DropdownMultiItemFilterComponent';
import getAssocsFromSessionStorage from '../helpers/sessionHandler';

class DropdownMultiItemComponent extends React.Component {
  static isAvailableFromSessionStorage(assoc) {
    let found = false;
    getAssocsFromSessionStorage().forEach((a) => {
      if (a === assoc.ID) {
        found = true;
      }
    });

    return found;
  }

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);

    const assocs = [];

    props.container.Associations.forEach((a) => {
      assocs.push({
        ID: a.ID,
        Name: a.Name,
        Checked: DropdownMultiItemComponent.isAvailableFromSessionStorage(a),
      });
    });

    this.state = {
      assocs,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.reset) {
      const { assocs } = prevState;
      assocs.forEach((a) => {
        a.Checked = false;
      });

      return {
        assocs,
      };
    }
    return null;
  }

  handleClick(e) {
    const { handleChange, container } = this.props;
    e.preventDefault();
    handleChange(container.ID);
  }

  handleChange(assoc, checked) {
    const { assocs } = this.state;
    const { setAssocs } = this.props;

    assocs.forEach((a) => {
      if (a.ID === assoc.ID) {
        a.Checked = checked;
      }
    });

    // this.props.dropDownSearch(assoc.ID, []);

    this.setState({ assocs });
    setAssocs(assocs);
    // this.props.setSelectedSubjects(assocs);
  }

  render() {
    const { container, selected } = this.props;
    const { assocs } = this.state;
    if (container.Associations.length < 1) {
      return (
        <li className={selected ? 'selected multi' : 'multi'}>
          <button type="button" onClick={this.handleClick}>
            {container.Name}
          </button>
        </li>
      );
    }

    const renderAssoc = assocs.map((a, i) => {
      const key = i;
      return (
        <DropdownMultiItemCheckboxComponent
          key={key}
          assoc={a}
          handleChange={this.handleChange}
        />
      );
    });

    let isChecked = false;
    assocs.forEach((a) => {
      if (a.Checked) {
        isChecked = true;
      }
    });

    const renderFilter = assocs.map((a, i) => {
      const key = i;
      if (a.Checked) {
        return (
          <DropdownMultiItemFilterComponent
            key={key}
            assoc={a}
            handleClick={this.handleChange}
          />
        );
      }
      return null;
    });

    return (
      <li className={selected ? 'open multi' : 'multi'}>
        <button type="button" onClick={this.handleClick}>
          {container.Name}
        </button>
        {(() => {
          if (isChecked) {
            return (
              <ul className="filter resetlist">
                {renderFilter}
              </ul>
            );
          }
          return null;
        })()}
        <ul className="associations resetlist">
          {renderAssoc}
        </ul>
      </li>
    );
  }
}

DropdownMultiItemComponent.propTypes = {
  container: PropTypes.shape({
    Associations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    ID: PropTypes.number.isRequired,
    Multi: PropTypes.bool.isRequired,
    Name: PropTypes.string.isRequired,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  reset: PropTypes.bool.isRequired,
  selected: PropTypes.bool.isRequired,
  setAssocs: PropTypes.func.isRequired,
};

DropdownMultiItemComponent.displayName = 'DropdownMultiItemComponent';

export default DropdownMultiItemComponent;
